import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CallbackProps } from "../interFaces/interfaces";
const Callback: React.FC<CallbackProps> = ({ setIsAuthenticated }) => {
  const navigate = useNavigate();
  useEffect(() => {
    const handleCallback = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get("token");
      if (token) {
        try {
          try {
            const payload = JSON.parse(atob(token.split(".")[1]));
            if (payload?.sub) {
              const email = payload.sub;
              localStorage.setItem("email", email);
            }
          } catch (error) {
            console.error("JWT payload decode failed:", error);
          }
          window.history.replaceState({}, document.title, window.location.pathname);
          localStorage.setItem("authEvent", JSON.stringify({ type: "LOGIN" }));
          setIsAuthenticated(true);
          navigate("/dashboard");
        } catch (error) {
          console.error("Callback handling failed:", error);
          navigate("/login");
        }
      } else {
        let retryCount = 0;
        const maxRetries = 5;
        const checkAndNavigate = () => {
          const hasAccessToken = document.cookie.includes("accessToken");
          if (hasAccessToken) {
            localStorage.setItem("authEvent", JSON.stringify({ type: "LOGIN" }));
            setIsAuthenticated(true);
            navigate("/dashboard");
          } else if (retryCount < maxRetries) {
            retryCount++;
            setTimeout(checkAndNavigate, 500);
          } else {
            navigate("/login");
          }
        };
        checkAndNavigate();
      }
    };
    handleCallback();
  }, [navigate, setIsAuthenticated]);
  return <div className="callback-container"></div>;
};
export default Callback;